export const LAST_CATEGORY_ID_FOR_MIGRATION = ['11111', '22222', '33333'];

/** Hours threshold: category is considered "changed" (not migration placeholder) if updated - created > this */
export const MIGRATION_CATEGORY_CHANGED_THRESHOLD_HOURS = 3;
export const MIGRATION_CATEGORY_CHANGED_THRESHOLD_MS =
  MIGRATION_CATEGORY_CHANGED_THRESHOLD_HOURS * 60 * 60 * 1000;

/**
 * Category is a migration placeholder (no real user title) when id ends with legacy suffix
 * and title is empty or comp-*. Used to hide category tabs when all categories are placeholders
 * (migrated site: show flat FAQ list without "General1" tab).
 */
export const isMigrationStyleCategory = (category: {
  id?: string | null;
  title?: string | null;
}): boolean => {
  const id = category?.id ?? '';
  const title = category?.title ?? '';
  const hasRealTitle =
    title.trim() !== '' && !title.toLowerCase().startsWith('comp-');
  return LAST_CATEGORY_ID_FOR_MIGRATION.includes(id.slice(-5)) && !hasRealTitle;
};
